import { render, staticRenderFns } from "./HomePageCompanyOwner.vue?vue&type=template&id=75b46532&"
import script from "./HomePageCompanyOwner.vue?vue&type=script&lang=ts&"
export * from "./HomePageCompanyOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports